import { IEventData } from 'meta/pages/v4/event'
import { IWalletEvent } from 'meta/pages/v4/wallet'
import { getFirstCollectionRelatedEventCode } from 'helpers/wallet/events'

import { useCollectionDetails, useCollectionEvents } from 'hooks/useCollection'
import { useCurrentLanguage } from 'hooks/useCurrentLanguage'
import { useEventData } from 'hooks/useEvent'
import { useLocationData } from 'hooks/useLocation'

import WalletTicketDesktop, { WalletTicketDesktopSkeleton } from '../WalletTicketDesktop'
import { mergeEventAndCollectionDataIntoEventData } from './adapter'

type EventProps = {
  isPastEvent?: boolean
  walletEventData: IWalletEvent
}

type LocationProps = {
  baseProps: EventProps
  eventData: IEventData
}

const EventCollectionContainer: React.FC<EventProps> = (props) => {
  const { walletEventData } = props

  const language = useCurrentLanguage()

  const eventCollectionData = useCollectionDetails({ id: String(walletEventData.id), language })
  const collectionEventsData = useCollectionEvents({ id: String(walletEventData.id), language })

  const collectionFirstEventCode = collectionEventsData?.data
    ? getFirstCollectionRelatedEventCode(collectionEventsData.data)
    : null
  const firstEventData = useEventData({ idOrCodeUrl: collectionFirstEventCode ?? 'NON_EXISTENT' })

  if (!eventCollectionData || !collectionEventsData || !firstEventData) {
    return <WalletTicketDesktopSkeleton />
  }

  const mergedEventData = mergeEventAndCollectionDataIntoEventData(firstEventData, eventCollectionData)

  return <LocationContainer eventData={mergedEventData} baseProps={props} />
}

const LocationContainer: React.FC<LocationProps> = (props) => {
  const { baseProps, eventData } = props

  const locationData = useLocationData({ idOrCodeUrl: String(eventData.locationId) })

  if (!locationData) {
    return <WalletTicketDesktopSkeleton />
  }

  return <WalletTicketDesktop locationData={locationData} eventData={eventData} baseProps={baseProps} />
}

export default EventCollectionContainer
